import { WebPlugin } from '@capacitor/core';
export class MediaSessionWeb extends WebPlugin {
    async setMetadata(options) {
        const mediaSession = navigator.mediaSession;
        if (!mediaSession) {
            throw this.unavailable('Media Session API not available in this browser.');
        }
        const MediaMetadataCtor = window.MediaMetadata;
        if (MediaMetadataCtor) {
            mediaSession.metadata = new MediaMetadataCtor(options);
        }
        else {
            mediaSession.metadata = options;
        }
    }
    async setPlaybackState(options) {
        const mediaSession = navigator.mediaSession;
        if (!mediaSession) {
            throw this.unavailable('Media Session API not available in this browser.');
        }
        mediaSession.playbackState = options.playbackState;
    }
    async setActionHandler(options, handler) {
        const mediaSession = navigator.mediaSession;
        if (!mediaSession) {
            throw this.unavailable('Media Session API not available in this browser.');
        }
        mediaSession.setActionHandler(options.action, handler);
    }
    async setPositionState(options) {
        const mediaSession = navigator.mediaSession;
        if (!mediaSession) {
            throw this.unavailable('Media Session API not available in this browser.');
        }
        mediaSession.setPositionState(options);
    }
    async getPluginVersion() {
        return { version: 'web' };
    }
}
//# sourceMappingURL=web.js.map